import React from "react";

interface IContactInfo {
  mail?: string;
  value?: string;
  telegram?: string;
  phone?: ({ text: string; value: string, icon?: JSX.Element })[];
  phoneGroup?: ({ text: string; value: string })[]
}

interface IContactsByCountry {
  [countryCode: string]: {
    support: IContactInfo;
    sales: {
      phone: string;
      value: string;
      mail: string;
      telegram?: { text: string; value: string, icon?: JSX.Element }
    };
    accounting: IContactInfo;
    partners: IContactInfo;
  };
}

export const CONTACTS_BY_COUNTRY: IContactsByCountry = {
  RU: {
    support: {
      mail: 'support@onlinepbx.ru',
      telegram : 'techpbx_bot',
      phone: [],
      phoneGroup: [
        {
          text: '+7 (495) 669-67-21',
          value: '+74956696721'
        },
        {
          text: '+7 (812) 646-51-40',
          value: '+78126465140',
        },
        {
          text: '+7 (343) 302-01-37',
          value: '+73433020137'
        },
      ],
    },
    sales: {
      phone: '+7 (495) 148-50-22',
      value: '+74951485022',
      mail: 'go@onlinepbx.ru',
    },
    accounting: {
      mail: 'fin@onlinepbx.ru',
    },
    partners: {
      mail: 'partner@onlinepbx.ru'
    }
  },
  UZ: {
    support: {
      mail: 'support@onlinepbx.ru',
      telegram : 'techpbx_bot',
      phone: [
      {
        text: '+998 (78) 113-26-50',
        value: 'tel:+998781132650',
      },
      {
        text: 'support@onlinepbx.uz',
        value: 'mailto:support@onlinepbx.uz',
      },
      {
        icon: <img src={process.env.PUBLIC_DIR + '/images/telegram-mini.svg'} className='onlinepbx__help__support__icon' />,
        text: 'onpbxuz_bot',
        value: 'https://t.me/onpbxuz_bot',
      }
      ],
      phoneGroup: []
    },
    sales: {
      phone: '+998 (78) 113-66-61',
      value: '+998781136661',
      mail: 'go@onlinepbx.uz',
      telegram: {
        icon: <img src={process.env.PUBLIC_DIR + '/images/telegram-mini.svg'} className='onlinepbx__help__support__icon' />,
        text: 'onlinepbx_sales',
        value: 'https://t.me/onlinepbx_sales',
      }
    },
    accounting: {
      mail: 'fin@onlinepbx.uz',
    },
    partners: {
      mail: 'partner@onlinepbx.ru',
      phone: [
        {
          text: '+998 (78) 113-66-68',
          value: 'tel:+998781136668',
        },
        {
          text: 'partner@onlinepbx.uz',
          value: 'mailto:partner@onlinepbx.uz',
        },
        {
          icon: <img src={process.env.PUBLIC_DIR + '/images/telegram-mini.svg'} className='onlinepbx__help__support__icon' />,
          text: 'onlinepbx_sales',
          value: 'https://t.me/onlinepbx_sales',
        }
      ],
    }
  },
  KZ: {
    support: {
      mail: 'support@onlinepbx.ru',
      telegram : 'techpbx_bot',
      phone: [{
        text: '+7 (708) 905-70-02',
        value: '+77089057002'
      },
      {
        text: 'support@onlinepbx.ru',
        value: 'mailto:support@onlinepbx.ru',
      },
        {
          icon: <img src={process.env.PUBLIC_DIR + '/images/telegram-mini.svg'} className='onlinepbx__help__support__icon' />,
          text: 'techpbx_bot',
          value: 'https://tlgg.ru/:techpbx_bot',
        }
      ],
      phoneGroup: []
    },
    sales: {
      phone: '+7 (708) 905-70-02',
      value: '+770890570026',
      mail: 'go@onlinepbx.ru',
    },
    accounting: {
      mail: 'fin@onlinepbx.ru',
    },
    partners: {
      mail: 'partner@onlinepbx.ru'
    }
  }
}
